export default __webpack_public_path__ + "static/media/crossfit.cdbc9bd9.jpg";